var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star_svg__Group_686",
    "data-name": "Group 686",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.059,
    height: 40,
    viewBox: "0 0 42.059 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_svg__Path_13",
    "data-name": "Path 13",
    d: "M15.152,13.886,1.074,15.932l10.187,9.929L8.856,39.882l12.591-6.62,12.591,6.62-2.4-14.021,10.187-9.929L27.744,13.886l-6.3-12.757Z",
    transform: "translate(-0.418 -0.44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "star_svg__Path_14",
    "data-name": "Path 14",
    d: "M11.116,25.632l.054-.317-.23-.224L1.312,15.7l13.307-1.933.317-.046.142-.288L21.029,1.38,26.98,13.438l.142.288.317.046L40.747,15.7l-9.629,9.386-.23.224.054.317,2.273,13.253-11.9-6.258-.284-.149-.284.149-11.9,6.258ZM21.029,0l-6.5,13.167L0,15.279,10.515,25.528,8.033,40l13-6.833,13,6.833L31.544,25.528,42.058,15.279,27.528,13.167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.24942215e61b8f051ee35e037039e944.svg";
export { ForwardRef as ReactComponent };